<template>
    <div class="modal vc_modal my_account_modal" :class="{ 'show': isShowModal}">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content my_account_modal_content p_0">
                <button type="button" class="btn-close" @click="closeModal()"></button>
                <div class="modal-body p_0">
                    <h5 class="common_subtitle pb_15  font_18p border-lightgray-bottom pt_15 pl_15">{{ modalData?.name }} details</h5>
                    <div class="p_20">
                        <div class="row">
                            <div class="col-6">
                                <div class="table_responsive w-100">
                                    <table class="common_table table table_bordered table-hover w-100 align-middle">
                                        <tbody>
                                            <tr>
                                                <th class="border_top_none transparent_bg"> Service</th>
                                                <td>{{ modalData?.cloudService?.name }}</td>
                                            </tr>
                                            <tr v-if="!modalData.proxmox_vm_id">
                                                <th class="transparent_bg">Kt platform</th>
                                                <td>{{ modalData?.kt_platform == 'g' ? 'G' : 'D' }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Public IP</th>
                                                <td>{{ modalData?.public_ip }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Region</th>
                                                <td>{{ modalData?.serverRegion?.name }}</td>
                                            </tr>
                                            <tr>
                                                <th class="border_bottom_none transparent_bg">Type</th>
                                                <td class="border_bottom_none">{{ modalData?.network_type }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> 
                            </div>
                            <div class="col-6">
                                <div class="table_responsive w-100">
                                    <table class="common_table table table_bordered table-hover w-100 align-middle">
                                        <tbody>
                                            <tr>
                                                <th class="transparent_bg">Explanation</th>
                                                <td>{{ modalData?.ip_note }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Static NAT</th>
                                                <td>{{ modalData?.cloudServer?.server_name }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Status</th>
                                                <td>{{ modalData?.status }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Billing type</th>
                                                <td>
                                                    {{ billing_type }}
                                                    <span class="ml_20" v-if="modalData?.network_type != 'default'">
                                                        <button type="button" v-if="hasPermission('Update') && modalData.kt_platform == 'g'" class="btn btn-outline-primary btn-sm" title="Change billing type" @click.prevent="openBillingTypeModal()">
                                                            <i class="fas fa-edit"></i>
                                                        </button>
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="border_bottom_none transparent_bg">Started at</th>
                                                <td class="border_bottom_none">{{ modalData?.started_at }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ServerBillingTypeEditModal
            v-if="showBillingTypeModal"
            :showBillingTypeModal="showBillingTypeModal"
            :modalData="modalData"
            @closeBillingTypeModal="closeBillingTypeModal"
        />
    </div>
</template>

<script>
import ServerBillingTypeEditModal from "./ServerBillingTypeEditModal.vue";
import {mapGetters} from "vuex";
import {checkPermission} from "@/mixins/permissionsHelper";
export default {
    name: "details-modal",
    components: { ServerBillingTypeEditModal },
    props: {
        isShowModal: {
            type: Boolean,
            required: true
        },
        modalData: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            billing_type: this.modalData?.billing_type,
            showBillingTypeModal: false,
        }
    },
    computed: {
        ...mapGetters({
            permissions: 'serverPermissions/getServicePermission'
        }),
    },
    watch: {
        
    },
    created() {
        
    },
    methods: {
        openBillingTypeModal(){
            this.showBillingTypeModal = true
            this.editModalData = this.modalData
        },
        closeBillingTypeModal(value = null){
            this.billing_type = value
            this.showBillingTypeModal = false
        },
        closeModal() {
            this.$emit('closeModal')
        },
        hasPermission(action) {
            let entity = this.permissions?.cloud_sub_service?.length ? this.permissions?.cloud_sub_service[0] : null;
            return checkPermission(this.permissions, entity, action);
        },
    }
}
</script>
<style scoped>
    .modal{
        background-color: rgb(0 0 0 / 15%);
    }
</style>
